import { FEATURE_GROUP_TO_URL_PARAM_MAP, FEATURE_TYPE_TO_FEATURE_GROUP_MAP, FEATURE_TYPE_TO_URL_PARAM_MAP } from './creditObjectUrlMaps';
const PRICING_URLS = {
  HUBSPOT_CREDITS: (portalId, upgradeSource = 'buy-credits') => `/pricing/${portalId}/add-ons?upgradeSource=${encodeURIComponent(upgradeSource)}`,
  HSOC_ADD_CREDITS: (portalId, upgradeSource = 'buy-credits') => `/pricing/${portalId}/?upgradeSource=${encodeURIComponent(upgradeSource)}&openMode=add-credits`
};
const ACCOUNT_AND_BILLING_URLS = {
  USAGE_HUBSPOT_CREDITS: portalId => `/account-and-billing/${portalId}/usage/hubspot-credits`,
  USAGE_FEATURE_TYPE: (portalId, featureType) => {
    const featureGroup = FEATURE_TYPE_TO_FEATURE_GROUP_MAP[featureType];
    const featureGroupParam = FEATURE_GROUP_TO_URL_PARAM_MAP[featureGroup];
    const featureTypeParam = FEATURE_TYPE_TO_URL_PARAM_MAP[featureType];
    return `/account-and-billing/${portalId}/usage/hubspot-credits/feature-group/${featureGroupParam}/feature-type/${featureTypeParam}`;
  }
};
const KNOWLEDGE_BASE_URLS = {
  CREDITS: 'https://knowledge.hubspot.com/account-management/understand-hubspot-credits-and-billing',
  CUSTOMER_AGENT: 'https://knowledge.hubspot.com/customer-agent/create-a-customer-agent'
};
const NORDICS_PRICING_URL = 'https://www.hubspot.com/Nordic-customer-pricing';
const LEGAL_BASE_URLS = {
  CREDITS_RATE_SHEET: 'https://legal.hubspot.com/hubspot-product-and-services-catalog#HubSpotCreditsRateSheet'
};
const FEATURE_TYPE_TO_KB_URL_MAP = {
  CUSTOMER_AGENT: KNOWLEDGE_BASE_URLS.CUSTOMER_AGENT
};
function getKbUrlForFeatureType(featureType) {
  var _FEATURE_TYPE_TO_KB_U;
  return (_FEATURE_TYPE_TO_KB_U = FEATURE_TYPE_TO_KB_URL_MAP[featureType]) !== null && _FEATURE_TYPE_TO_KB_U !== void 0 ? _FEATURE_TYPE_TO_KB_U : KNOWLEDGE_BASE_URLS.CREDITS;
}
export { ACCOUNT_AND_BILLING_URLS, FEATURE_TYPE_TO_KB_URL_MAP, getKbUrlForFeatureType, KNOWLEDGE_BASE_URLS, LEGAL_BASE_URLS, NORDICS_PRICING_URL, PRICING_URLS };